<template>
  <el-dialog
    title
    :visible.sync="show"
    :close-on-click-modal="false"
    width="550px"
    class="user-bind-modal"
    @close="onChange"
  >
    <div slot="title">
      {{ $t('after-sales::in-box::history_bind_customer') }}
    </div>

    <el-form class="user-body" ref="form" :model="params" :rules="rules" label-width="100px">
      <el-form-item
        :label="t('after-sales::in-box::history_order_num')"
        prop="orderNo"
        v-if="params.type === 'orderNo'"
      >
        <el-input
          v-model.trim="params.orderNo"
          class="input-item"
          :placeholder="t('after-sales::in-box::history_order_num_holder')"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="t('after-sales::in-box::history_order_email')"
        prop="emailBind"
        v-if="params.type === 'email'"
      >
        <el-input
          v-model.trim="params.emailBind"
          class="input-item"
          :placeholder="t('after-sales::in-box::history_order_email_holder')"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="check-info">
      <span>
        <a @click="handleCheck('email')" v-if="params.type === 'orderNo'">
          {{ $t('after-sales::in-box::history_email_usage') }}
        </a>
        <a @click="handleCheck('orderNo')" v-if="params.type === 'email'">
          {{ $t('after-sales::in-box::history_ordernum_usage') }}
        </a>
      </span>
    </div>
    <div class="tip-info">
      {{ $t('after-sales::in-box::history_order_tips') }}
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="onChange">{{ $t('after-sales::in-box::history_btn_cancel') }}</el-button>
      <el-button type="primary" @click="onSave" :loading="loading">
        {{ $t('after-sales::in-box::history_btn_confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import { postUserBindingEmail } from '@/server/after-sales'
export default {
  name: 'modal-email',
  components: {},
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      default: false
    },
    drawRow: {
      default: () => {}
    }
  },
  watch: {
    visible (bool) {
      this.show = bool
      const data = this.drawRow
      this.params = {
        type: 'orderNo',
        emailBind: '',
        inboxId: data.item.inboxId,
        orderNo: ''
      }
      this.$nextTick(() => this.$refs.form.clearValidate())
    },
    drawRow: {
      handler: function (data) {},
      deep: true
    }
  },
  data () {
    return {
      loading: false,
      rules: {
        orderNo: [{ required: true, message: this.$t('after-sales::in-box::history_order_num_holder'), trigger: 'change' }],
        emailBind: [
          { required: true, message: this.$t('after-sales::in-box::history_order_email_holder'), trigger: 'change' },
          { type: 'email', message: this.$t('after-sales::in-box::history_correct_holder') }
        ]
      },
      show: false,
      params: {}
    }
  },
  mounted () {},
  methods: {
    t (key) {
      return this.$t(key)
    },
    onChange () {
      this.$emit('change', false)
    },
    onSave () {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          this.loading = true
          let params = {
            inboxId: this.params.inboxId
          }
          if (this.params.type === 'orderNo') {
            params.orderNo = this.params.orderNo
          } else {
            params.emailBind = this.params.emailBind
          }
          const { data } = await postUserBindingEmail(params)
          if (data.code === this.$code) {
            this.$message.success(this.$t('system::tip::control_success'))
            this.$emit('save')
            this.$emit('change', false)
          }
          this.loading = false
        }
      })
    },
    handleCheck (type) {
      this.$refs.form.resetFields()
      this.params.type = type
    }
  }
}
</script>
<style lang="scss" scoped>
.user-bind-modal {
  .user-body {
    .input-item {
    }
  }
  .check-info {
    margin-bottom: 10px;
  }
  .tip-info {
    color: $--color-info;
  }
}
</style>
